import React from 'react'
import { RefundBlock, RefundTitle, RefundSeparatorWrapper } from './../style'
import { FormattedMessage } from 'react-intl'
import { ButtonBorder, ButtonFull } from 'components/Form/Button'
import { getCartFinal } from '../thunk'
import { useDispatch } from 'react-redux'
import { SS } from 'utils/common'
import { Icon } from 'components/Icon'

const RefundPopup = ({ totals = {}, partialRequestData, currency = '' }) => {
	const dispatch = useDispatch()
	const props = SS.get('shopProperties')
	const isCreditEnabled = props
		? props['store.credit.enabled'] === 'true'
			? true
			: false
		: false

	return (
		<RefundBlock>
			<RefundTitle>
				<FormattedMessage
					id='gcSuggestion.dialog.title'
					defaultMessage='Refund'
				/>
			</RefundTitle>

			<RefundSeparatorWrapper>
				<Icon component='RefundSeparator' />
			</RefundSeparatorWrapper>

			{isCreditEnabled ? (
				<>
					<br />
					<ButtonFull
						dark
						w419
						onClick={() => {
							dispatch(getCartFinal(partialRequestData))
						}}
					>
						<FormattedMessage
							id='gcFinal.dialog.giftValue'
							defaultMessage='Store Credit'
						/>
					</ButtonFull>
				</>
			) : (
				<>
					<br />
					<ButtonBorder
						w100
						w419
						onClick={() => {
							dispatch(getCartFinal(partialRequestData))
						}}
					>
						<FormattedMessage
							id='gcSuggestion.dialog.refund.button'
							defaultMessage='REFUND OR CREDIT INVOICE'
						/>
					</ButtonBorder>
				</>
			)}
		</RefundBlock>
	)
}

export default RefundPopup
